// extracted by mini-css-extract-plugin
export default {"menu":"MenuMobile_menu__CEtb+"};